export default __webpack_public_path__ + "static/media/acm.7a1294e3.svg";